
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[authorUsername]/blog",
      function () {
        return require("private-next-pages/author/[authorUsername]/blog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[authorUsername]/blog"])
      });
    }
  